import React, { useEffect } from "react"
import SignupLayout from ".";
import BackgroundImg from "../../assets/images/background/company-details.png";
import { AboutYourCompanyBagIcon, AboutYourCompanyIcon } from "../../components/Icons/iconImages";
import InputField from "../../components/InputField";
import { validationConstants } from "../../constants/validations";
import { Button, Select } from "antd";
import { Controller, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import Icons from '../../components/Icons';
import { IndustryOptions, RolesOptions, TimeZones } from "../../constants/data";
import { signInCognitoUser } from "../../services/auth";
import ReactGA from "react-ga4";


const AboutYourCompany = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { state } = location;
    const [header, setHeader] = React.useState({})
    const defaultValues = {
        code: '',
        industry: "",
        role: "",
        companySize: "",
        url: ""
    };

    const {
        getValues,
        setValue,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm({
        defaultValues,
    });
    const signIn = async () => {
        try {
            const user: any = await signInCognitoUser(state.email, state.password);
            if (user) {
                const tempHeader = {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user?.idToken?.jwtToken}`,
                }
                setHeader(tempHeader);
            }
        } catch (err) {
            console.error('SignIn error:', err);
        }
    }
    useEffect(() => {
        if (state?.email && state?.password) {
            signIn();
        }
        if (state?.header) {
            setHeader(state?.header);
        }
        if (state?.aboutCompany) {
            setValue('code', state?.aboutCompany?.code);
            setValue('industry', state?.aboutCompany?.industry);
            setValue('role', state?.aboutCompany?.role);
            setValue('companySize', state?.aboutCompany?.companySize);
            setValue('url', state?.aboutCompany?.url);
        }
    }, [state])



    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const handleSignUp = (data: any) => {
        ReactGA.event('company_info_added', {
            method: 'manual_entry',
            user_type: 'new_user',
        });

        navigate('/integration-pereference', {
            state: {
                ...state,
                header,
                aboutCompany: data
            }
        });
    }
    const handleSubmitError = (data: any) => {
        // console.log('error triggered', data)
    }

    return (
        <SignupLayout
            title={<p className="text-[#FFFFFF] font-bold text-6xl 2xl:text-7xl mt-3">Smarter Decisions, Higher Returns!</p>}
            description={<p className="text-[#FFFFFF] text-xl mt-3">Businesses using our tool have uncovered powerful insights and improved their
                {' '}  <span className="relative border border-[#FDB022] text-[#F79009] font-semibold px-1.5 py-0.5 bg-[#325142] inline-block">
                    <span className="absolute h-[5px] w-[5px] top-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] top-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] right-[-3px] bg-[#FDB022]"></span>
                    <span className="absolute h-[5px] w-[5px] bottom-[-3px] left-[-3px] bg-[#FDB022]"></span>
                    ROAS by up to 40%.
                </span>{' '}
                Connect your platforms now and see the difference!</p>}
            // background={BackgroundImg}
            icon={<AboutYourCompanyIcon className="h-[80px] w-[80px] " />}
            percent={50}
            currentStep={3}
            routeState={{
                ...state,
                header,
                aboutCompany: getValues()
            }
            }
        >
            <div className="h-[100vh] max-w-[480px] mx-auto w-full overflow-y-auto">
                <div className=" text-center mt-8">
                    <div className="border border-gray-300 w-[56px] h-[56px] rounded-xl flex items-center justify-center m-auto shadow-sm">
                        <AboutYourCompanyBagIcon className="mx-auto text-center block" />
                    </div>
                    <p className="text-[#181D27] font-semibold text-3xl mt-4">Tell us about your company</p>
                    <p className="text-[#535862] text-md mt-2">A few details to set things up for you and your team</p>
                </div>
                <form onSubmit={handleSubmit(handleSignUp, handleSubmitError)} className="flex flex-col items-center mt-6 gap-6">
                    <div className="max-w-[416px] w-full rounded-2xl flex flex-col space-y-4 md:space-y-4">
                        <InputField
                            control={control}
                            label={'Company Name'}
                            placeholder={'Company Name'}
                            name="code"
                            rules={{
                                required: 'Company Name is required',
                            }}
                            error={errors.code}
                        />

                        <div>
                            <p className="text-sm text-[#414651] font-medium">
                                Industry<span className="pl-1 text-green-500">*</span>
                            </p>
                            <Controller
                                control={control}
                                name="industry"
                                rules={{
                                    required: { value: true, message: "Industry is required" },
                                }}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <Select
                                            {...field}
                                            className={`h-12 rounded-full w-full ${error ? "border-red-500" : "border-gray-300"}`}
                                            options={IndustryOptions.map((res) => ({ value: res, label: res }))}
                                            showSearch
                                            value={field.value}
                                            placeholder="Select Industry"
                                            onChange={(value) => field.onChange(value)}
                                            style={{ border: error ? "1px solid #F87171" : "" }}
                                        />
                                        {error && <p className="text-xs tracking-tight leading-5 text-red-500">{error.message}</p>}
                                    </>
                                )}
                            />
                        </div>


                        <div>
                            <p className="text-sm text-[#414651] font-medium">
                                Your Role<span className="pl-1 text-green-500">*</span>
                            </p>
                            <Controller
                                control={control}
                                name="role"
                                rules={{
                                    required: { value: true, message: "Role is required" },
                                }}
                                render={({ field, fieldState: { error } }) => (
                                    <>
                                        <Select
                                            {...field}
                                            className={`h-12 rounded-full w-full ${error ? "border-red-500" : "border-gray-300"}`}
                                            options={RolesOptions.map((res) => ({ value: res, label: res }))}
                                            showSearch
                                            placeholder="Select Role"
                                            onChange={(value) => field.onChange(value)}
                                            style={{ border: error ? "1px solid #F87171" : "" }}
                                        />
                                        {error && <p className="text-xs tracking-tight leading-5 text-red-500">{error.message}</p>}
                                    </>
                                )}
                            />
                        </div>
                        <div>
                            <p className="text-sm text-[#414651] font-medium">
                                Company Size
                            </p>
                            <div className='py-3'>
                                <Controller
                                    control={control}
                                    name="companySize"
                                    render={({ field: { onChange, value } }) => (
                                        <div className="flex flex-wrap items-center gap-2">
                                            {[
                                                { label: 'Small', value: 'Small' },
                                                { label: 'Medium', value: 'Medium' },
                                                { label: 'Enterprise', value: 'Enterprise' },
                                            ].map((tab, index) => (
                                                <span
                                                    key={index}
                                                    className={`cursor-pointer text-xs w-fit font-normal inline-flex items-center px-4 py-2 rounded-full  ${value === tab.value ? "border border-[#B6F0D5] text-[#FFFFFF] bg-[#609F81] font-semibold" : "border border-gray-400 text-[#414651] font-semibold bg-gray-100"}`}
                                                    onClick={() => onChange(tab.value)}
                                                >
                                                    {tab.label}
                                                </span>
                                            ))}
                                        </div>
                                    )}
                                />
                            </div>
                        </div>

                        <InputField
                            control={control}
                            label={'Website url'}
                            placeholder={'www.yourwebsite.com'}
                            name="url"
                            rules={{
                                required: 'Url is required',
                            }}
                            error={errors.url}
                        />


                        {error && (
                            <div className="flex items-center justify-between w-full border-t border-gray-200 dark:border-gray-600 pt-4">
                                <p className='text-red-500 text-sm'>{error}</p>
                                <Icons icon={"heroicons-outline:x-circle"} className="max-h-5 max-w-5 h-5 w-5 text-red-500 cursor-pointer" onClick={() => setError(null)} />
                            </div>
                        )}
                    </div>
                    <Button
                        type='primary'
                        className="w-full max-w-[416px] mb-6"
                        disabled={loading}
                        loading={loading}
                        // onClick={() => handleSignUp()}
                        htmlType="submit"

                    >
                        Continue
                    </Button>
                </form>
            </div>

        </SignupLayout>
    )
};

export default AboutYourCompany;
